import { memo } from 'react';
import { PhoneNumber, useTranslation, InputValidations } from '@nextgen-web-framework/all';
import { ConfigService } from '@nextgen-web-framework/core';
import InputErrorComponent from '../InputErrorComponent/InputErrorComponent';
import { PhoneNumberInputProps } from './types/propTypes';

const PhoneNumberInput = ({
  name,
  phoneInputHideCountry,
  validationStatus,
  validationMessage,
  isAutoValidate,
  meta,
  ...props
}: PhoneNumberInputProps) => {
  const t = useTranslation();

  const { PHONE_INPUT_HIDE_COUNTRY, NEXT_PUBLIC_PHONE_NUMBER_SHOW_LEADING_ZERO } = ConfigService.getConfigs();
  const configPhoneInputHideCountry = phoneInputHideCountry ?? PHONE_INPUT_HIDE_COUNTRY;

  const errorMsg = validationStatus === InputValidations.INVALID && validationMessage ? validationMessage : '';

  let autoValidate = isAutoValidate;
  if (isAutoValidate === undefined && meta) {
    autoValidate = meta.touched;
  }

  return (
    <div>
      <PhoneNumber
        name={name}
        {...props}
        hideDropdown={Boolean(configPhoneInputHideCountry)}
        autoLeadingZero={Boolean(NEXT_PUBLIC_PHONE_NUMBER_SHOW_LEADING_ZERO)}
        isAutoValidate={autoValidate}
        {...(!isAutoValidate ? { status: validationStatus } : {})}
      />
      {errorMsg && <InputErrorComponent t={t} touched={true} error={errorMsg} />}
    </div>
  );
};

export default memo(PhoneNumberInput);
